import React from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import produce from 'immer';
import { DISPLAY_COMPONENT_META } from 'screens/analytics/tableCellComponents';
import styled, { css } from 'styled-components';

import ObjectiveTableRow from './ObjectiveTableRow';

/**
 * @deprecated 02-04-2025
 */
const NestedObjectiveTable = ({
  headers,
  rows,
  updateRowData,
  fetchObjectiveData,
  fetchGoalsData,
  objectiveHeaderId,
  levelsForWhichLinesToBeDrawn,
  heirarchy,
  refetchData,
  currentPageNumber,
  parentObjective,
  setExpandedRowIds,
  expandedRowIds,
  rowsData,
  setData,
  updateRowDataModifiedForArray,
  addNewObjective,
  expandedRowIdsArray,
  selectedTimeBoundPeriodsTeamHub,
  isTeamHubView,
  loadingObjectiveTableData,
  setIsOpenCreateGoalPanelObjectiveTable,
  setTimeboundDetailsNestedObjectiveTable,
  setAfterGoalCreationNestedObjectiveTable,
}) => {
  // return useMemo( () => {

  const updateRowDataModified = (index, newObj) => {
    const updatedDataArray = produce(rows, (draft) => {
      draft[index] = newObj;
    });

    updateRowData(updatedDataArray, index);
  };

  return (
    <>
      {rows &&
        rows.map((rowObj, index) => (
          <StyledTableRow key={`objective-table-row-${index}`}>
            <StyledTableCell colSpan={headers.length} style={{ padding: 0, borderBottom: 0 }}>
              <Table>
                <StyledTableHead>
                  <StyledTableRow>
                    {headers &&
                      headers.map(({ id }, index) => {
                        const minWidth = '20rem';
                        const width = index === 0 ? `calc(100% - ${headers.length - 1} * ${minWidth})` : `${minWidth}`;
                        return (
                          <StyledTableCell
                            key={`${id}`}
                            // width={width}
                            style={{ width }}
                            size="small"
                          />
                        );
                      })}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody isExpanded={expandedRowIdsArray?.includes(rowObj?.dataObj['1']?.uuid)}>
                  <ObjectiveTableRow
                    key={index}
                    headers={headers}
                    rowObj={rowObj}
                    updateRowData={updateRowDataModified}
                    updateRowDataModifiedForArray={updateRowDataModifiedForArray}
                    addNewObjective={addNewObjective}
                    fetchObjectiveData={fetchObjectiveData}
                    fetchGoalsData={fetchGoalsData}
                    objectiveHeaderId={objectiveHeaderId}
                    isLastElement={index === rows.length - 1}
                    // to decide which levels will have a vertical line.
                    levelsForWhichLinesToBeDrawn={
                      index === rows.length - 1 || rowObj.level === 0
                        ? levelsForWhichLinesToBeDrawn
                        : [...levelsForWhichLinesToBeDrawn, rowObj.level]
                    }
                    heirarchy={[
                      ...heirarchy,
                      {
                        ...rowObj.dataObj[
                          headers.find((hObj) => hObj.uuidType === DISPLAY_COMPONENT_META.OBJECTIVE.id)?.id
                        ],
                        index,
                      },
                    ]}
                    index={index}
                    refetchData={refetchData}
                    currentPageNumber={currentPageNumber}
                    parentObjective={parentObjective}
                    setExpandedRowIds={setExpandedRowIds}
                    expandedRowIds={expandedRowIds}
                    rows={rows}
                    rowsData={rowsData}
                    setData={setData}
                    expandedRowIdsArray={expandedRowIdsArray}
                    selectedTimeBoundPeriodsTeamHub={selectedTimeBoundPeriodsTeamHub}
                    isTeamHubView={isTeamHubView}
                    loadingObjectiveTableData={loadingObjectiveTableData}
                    setIsOpenCreateGoalPanelObjectiveTable={setIsOpenCreateGoalPanelObjectiveTable}
                    setTimeboundDetailsNestedObjectiveTable={setTimeboundDetailsNestedObjectiveTable}
                    setAfterGoalCreationNestedObjectiveTable={setAfterGoalCreationNestedObjectiveTable}
                  />
                </StyledTableBody>
              </Table>
            </StyledTableCell>
          </StyledTableRow>
        ))}
    </>
  );
  // }, [headers, rows, updateRowData, fetchObjectiveData, fetchGoalsData]);
};

const StyledTableRow = styled(TableRow)`
  th,
  td {
    border-bottom: 1px solid ${(props) => props.theme.palette.borders.lightGrey};
  }
  ${(props) =>
    props.hasBottomBorder &&
    css`
      border-bottom: 1px solid ${props.theme.palette.borders.lightGrey};
    `}
`;

const StyledTableCell = styled(TableCell)`
  position: relative;
  border-left: ${(props) => props.borderLeft && `1px solid ${props.theme.palette.borders.lightGrey}`};
  cursor: ${(props) => (props.isSortable ? 'pointer' : 'default')};
  ${(props) =>
    props.hoverable &&
    css`
      &:hover {
        background-color: ${(props) => props.theme.palette.background.lightBlue};
      }
    `}
`;

const StyledTableHead = styled(TableHead)`
  tr > th,
  tr > td {
    padding: 0;
    border-bottom: none !important;
  }
`;

const StyledTableBody = styled(TableBody)``;

export default NestedObjectiveTable;
